document.addEventListener(
"DOMContentLoaded",
() => {

const size =
document.getElementById(
"baseSize"
);

const color =
document.getElementById(
"baseColor"
);

if(
!size ||
!color ||
!window.EMB_PRODUCT_DATA
){
return;
}

const variants =
window.EMB_PRODUCT_DATA.variants;

/*
-------------------------
BUILD SIZE OPTIONS
-------------------------
*/

const sizes =
[
...new Set(
variants.map(
v => v.option1
)
)
];

size.innerHTML = "";

sizes.forEach(s => {

const option =
document.createElement(
"option"
);

option.value = s;
option.textContent = s;

size.appendChild(
option
);

});

/*
-------------------------
BUILD COLOR OPTIONS
-------------------------
*/

function populateColors() {

const selectedSize =
size.value;

const colors =
[
...new Set(
variants
.filter(
v =>
v.option1 === selectedSize
)
.map(
v => v.option2
)
)
];

color.innerHTML = "";

colors.forEach(c => {

const option =
document.createElement(
"option"
);

option.value = c;
option.textContent = c;

color.appendChild(
option
);

});

}

/*
-------------------------
UPDATE VARIANT
-------------------------
*/

function updateVariant() {

const selectedSize =
size.value;

const selectedColor =
color.value;

const variant =
variants.find(v => {

return (
v.option1 === selectedSize &&
v.option2 === selectedColor
);

});

if(!variant){
return;
}

window.currentEmbroideryVariant =
variant;
updateBasePrice(
  variant
);
console.log(
"ACTIVE VARIANT",
variant.id
);

updateBaseImage(
variant
);

document.dispatchEvent(
new CustomEvent(
"embroideryUpdated"
)
);

}

/*
-------------------------
IMAGE SWAP
-------------------------
*/

function updateBaseImage(
variant
){

const img =
document.getElementById(
"embroideryBaseImage"
);

if(!img){
return;
}

if(
variant.featured_image &&
variant.featured_image.src
){

img.src =
variant.featured_image.src;

}

}

/*
-------------------------
EVENTS
-------------------------
*/

size.addEventListener(
"change",
() => {

populateColors();

updateVariant();

}
);

color.addEventListener(
"change",
updateVariant
);

/*
-------------------------
INITIAL LOAD
-------------------------
*/

populateColors();

updateVariant();

}
);
function updateBasePrice(
  variant
){

  const display =
    document.getElementById(
      "base-price-display"
    );

  if(!display) return;

  const price =
    (
      variant.price / 100
    ).toFixed(2);

  display.textContent =
    `$${price}`;

  document.dispatchEvent(
    new CustomEvent(
      "embroideryPriceChanged"
    )
  );

}